<div 
  appScrollList 
  [activeIndex]="(activeCategoryIndex$ | async) ?? 0" 
  *ngIf="{
    isSearching: isSearching$ | async,
    items: items$ | async
  } as data"
>
  <div 
    class="menu-section" 
    appObserver
    [intersectionOptions]="intersectionOptions"
    (leaveEnd)="leaveEnd(category.slug, data.isSearching)"
    appScrollItem
    *ngFor="let category of categories$ | async" 
    [attr.data-category-slug]="category.slug"
  >
    <ng-container *ngIf="data.items!.get(category.id)">
      <div class="menu-section__head">
        <div class="menu-section__title h1">{{ category.name }}</div>
          <div class="menu-section__right" *ngIf="schedule$ | async as schedule">
            <div class="menu-section__caption">
              <span i18n="@@AvailableFrom">Available from</span> {{ schedule.from }} <span i18n="@@To">to</span> {{ schedule.to }}
            </div>
          </div>
      </div>
      <div class="menu-section__list">
        <div class="menu-section__item" *ngFor="let item of data.items!.get(category.id)">
          <app-product-card [data]="item"></app-product-card>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<router-outlet></router-outlet>
